<!--all p-table attributes must be set to its default values as stated in the primeng document-->
<p-table #dt [columns]="columns" [value]="value" [dataKey]="dataKey"
         [rows]="rows" [sortField]="sortField" [sortOrder]="sortOrder" [sortMode]="sortMode" [multiSortMeta]="multiSortMeta"
         (sortFunction)="sortFunction($event, customSortField, customSortLogic)" [customSort]="customSort"
         [responsive]="true" [(selection)]="selection" [selectionMode]="selectionMode"
         [expandedRowKeys]="expandedRowKeys" [rowExpandMode]="rowExpandMode"
         [(contextMenuSelection)]="contextMenuSelection" [contextMenuSelectionMode]="contextMenuSelectionMode" [contextMenu]="contextMenu"
         [paginator]="paginator" [rowsPerPageOptions]="rowsPerPageOptions"
         [stateStorage]="stateStorage" [stateKey]="stateKey" [globalFilterFields]="globalFilterFields"
         (onRowExpand)="onRowExpanded($event)">

  <ng-template pTemplate="caption">
    <app-default-caption [captionTemplate]="captionTemplate" [leftCaptionTemplate]="leftCaptionTemplate" [rightCaptionTemplate]="rightCaptionTemplate"
                         [searchCaptionTemplate]="searchCaptionTemplate" [disableSearch]="disableSearch"
                         [enabledExport]="enabledExport" [exportUsingTableColumn]="exportUsingTableColumn" [exportTableColumns]="exportTableColumns" [exportFileName]="exportFileName"
                         [dt]="dt">
    </app-default-caption>
  </ng-template>

  <ng-template pTemplate="header">
    <ng-container *ngTemplateOutlet="headerTemplate ? headerTemplate: defaultHeaderTemplate ; context: {columns : columns} ">
    </ng-container>
  </ng-template>

  <ng-template pTemplate="body" let-row let-rowIndex="rowIndex" let-columns="columns" let-expanded="expanded">
    <ng-container *ngTemplateOutlet="bodyTemplate ? bodyTemplate: defaultBodyTemplate ; context: {columns : columns, row:row, rowIndex: rowIndex, expanded: expanded} ">
    </ng-container>
  </ng-template>

  <ng-template *ngIf="footerTemplate" pTemplate="footer" let-row let-rowIndex="rowIndex" let-columns="columns">
    <ng-container *ngTemplateOutlet="footerTemplate; context: {columns : columns, row:row, rowIndex: rowIndex} ">
    </ng-container>
  </ng-template>

  <ng-template *ngIf="!disableEmptyMessage" pTemplate="emptymessage" let-columns>
    <ng-container *ngTemplateOutlet="emptyMessageTemplate ? emptyMessageTemplate: defaultEmptyMessageTemplate ; context: {columns : columns} ">
    </ng-container>
  </ng-template>

  <ng-template *ngIf="rowExpansionTemplate" pTemplate="rowexpansion" let-row let-rowIndex="rowIndex" let-columns="columns" let-expanded="expanded">
    <ng-container *ngTemplateOutlet="rowExpansionTemplate ; context: {columns : columns, row:row, rowIndex: rowIndex, expanded: expanded} ">
    </ng-container>
  </ng-template>

  <ng-template *ngIf="summaryTemplate" pTemplate="summary">
    <ng-container *ngTemplateOutlet="summaryTemplate">
    </ng-container>
  </ng-template>

</p-table>

<ng-template #defaultHeaderTemplate let-columns="columns">
  <tr>
    <th *ngFor="let col of columns" [pSortableColumn]="col.field" [style]="col.app === TableApp.Expansion ? 'text-align:center;width:50px;' : col.columnStyle">
      <ng-container *ngIf="col.headerTemplate"
                    [ngTemplateOutlet]="col.headerTemplate"
                    [ngTemplateOutletContext]="{col: col}"></ng-container>
      <div *ngIf="!col.headerTemplate">
        {{col.header}}
        <p-sortIcon *ngIf="col.field!=='action' && col.app!==TableApp.Expansion && !col.disableSortIcon" [field]="col.field"></p-sortIcon>
<!--        Not using p-button  to accommodate expansion when fieldset is disabled-->
        <!--        FixMe aaron: rel-1.3 style of moving -10px is a manual fix; not sure why this is not center align specified in the "th" style-->
        <a *ngIf="enableAllRowExpansion && col.app === TableApp.Expansion">
          <i [ngClass]="allRowsExpanded ? 'fa fa-sort-down' : 'fa fa-caret-right'" (click)="onClickExpandOrCollapseAllRows()"></i>
        </a>

      </div>
    </th>
  </tr>
</ng-template>

<ng-template #defaultBodyTemplate let-row="row" let-rowIndex="rowIndex" let-columns="columns" let-expanded="expanded">

  <tr [pSelectableRow]="row" [pContextMenuRow]="row">
    <td *ngFor="let col of columns" [style]="col.columnStyle">
      <span class="p-column-title">{{col.header}}</span>
      <span class="p-cell">
        <app-data-table-renderer [row]="row" [col]="col" [rowIndex]="rowIndex" [expanded]="expanded"></app-data-table-renderer>
      </span>
    </td>
  </tr>
</ng-template>

<ng-template #defaultEmptyMessageTemplate let-columns="columns">
  <tr>
    <td [attr.colspan]="columns?.length">
      No records found
    </td>
  </tr>
</ng-template>
